const rs = [
    {
        // 普华永道 pwc
        path: "/activity/pwc",
        name: "ActivityPwc",
        component: () => import("@/views/Activity/pwc"),
        redirect: "/activity/pwc/realMockExam",
        children: [
            {
                path: "realMockExam",
                name: "pwcRealMockExam",
                component: () => import("@/views/Activity/pwc/RealMockExam"),
                redirect: '/activity/pwc/realMockExam/step1',
                children: [{
                    path: 'step1',
                    name: 'pwcStep1',
                    component: () => import('@/views/Activity/pwc/RealMockExam/step1')
                },
                    {
                        path: 'step2',
                        name: 'pwcStep2',
                        component: () => import('@/views/Activity/pwc/RealMockExam/step2')
                    }]
            },
            {
                path: "ordinaryExam",
                name: "pwcOrdinaryExam",
                component: () => import("@/views/Activity/pwc/pwcOrdinaryExam")
            },
            {   //税务局等机考入口 列表选择
                path: "pwcList",
                name: "pwcList",
                component: () => import("@/views/Activity/pwc/pwcList")
            }
        ]
    },
    {
        // 朝阳税务局
        path: "/activity/cyswj",
        name: "ActivityCy",
        component: () => import("@/views/Activity/cyswj"),
        redirect: "/activity/cyswj/realMockExam",
        children: [
            {
                path: "realMockExam",
                name: "pwcRealMockExam",
                component: () => import("@/views/Activity/cyswj/RealMockExam"),
                redirect: '/activity/cyswj/realMockExam/step1',
                children: [{
                    path: 'step1',
                    name: 'pwcStep1',
                    component: () => import('@/views/Activity/cyswj/RealMockExam/step1')
                }]
            },
            {
                path: "ordinaryExam",
                name: "pwcOrdinaryExam",
                component: () => import("@/views/Activity/cyswj/pwcOrdinaryExam")
            }
        ]
    },
    {
        // 万人模考活动
        // 模考普通卷（一模二模）
        path: '/moKao/activityOrdinary',
        name: 'moKaoActivityOrdinary',
        component: () => import('@/views/Activity/MoKao/activityOrdinary')
    },
    {
        // 模考随机卷（自由模考）
        path: '/moKao/activity',
        name: 'moKaoActivity',
        component: () => import('@/views/Activity/MoKao/activity')
    },
    {
        // 模考解析页面
        path: '/moKao/moKaoAnalysis',
        name: 'moKaoAnalysis',
        meta: {title: '答案解析'},
        component: () => import('@/views/Activity/MoKao/moKaoAnalysis')
    },
    {
      // 闯关大赛
      path: '/chuangGuan/activityOrdinary',
      name: 'moKaoActivity',
      component: () => import('@/views/Activity/ChuangGuan/activityOrdinary')
    }

]
export default rs
